/* BEGIN LivePerson View cart Monitor. */
(function($) {
  $(document).ready(function() {
    var url = this.location.pathname;
    var cart_url = '/checkout/viewcart.tmpl';
    var confirmation_url = '/checkout/confirm.tmpl';
    var prod_url = '^\/product\/';
    var lpTag = window.lpTag || {};
    var i;
    var ii;
    var productarray = [];

    $(document).on('addToCart.success', function(event, data) {
      var cartItems = data.trans_data.order.items;
      var cartInformation = {};
      cartInformation['type'] = 'cart';
      cartInformation['total'] = 0;
      cartInformation['numItems'] = cartItems.length;
      cartInformation['products'] = [];
      cartItems.forEach(function(product) {
        var products = {};
        products['product'] = {};
        products['product']['name'] = product['prod.PROD_RGN_NAME'];
        products['product']['category'] = product['prod.FAMILY_CODE'];
        products['product']['sku'] = product['sku.SKU_ID'];
        products['product']['price'] = product['UNIT_PRICE'];
        products['quantity'] = product['ITEM_QUANTITY'];
        cartInformation['total'] += product['APPLIED_PRICE'];
        cartInformation['products'].push(products);
      });
      lpTag.sdes = lpTag.sdes || [];
      lpTag.sdes.push(cartInformation);
    });
    /* END LivePerson View cart Monitor. */

    /* Visitor Error Track */
    function lpTrackVisitorError(message, code) {
      lpTag.sdes = lpTag.sdes || [];
      lpTag.sdes.push({
        'type': 'error', //MANDATORY
        'error': {
          'message': message, // THE ERROR MESSAGE
          'code': code // THE ERROR CODE
        }
      });
    }

    var error_tag = {'no_search_result': {'message': 'No items found matching', 'code': 'er001'}};

    $(document).one('endeca.search.results.loaded', function(event, data) {
      var productData = data.results.products.resultData || {};
      if (productData.length === 0) {
        if (lpTag) {
          lpTrackVisitorError(error_tag['no_search_result']['message'], error_tag['no_search_result']['code']);
        }
      }
    });

    var totalCost = page_data && page_data.data && page_data.data.transaction && page_data.data.transaction.trans && page_data.data.transaction.trans.payments[0] && page_data.data.transaction.trans.payments[0].PAYMENT_AMOUNT ? page_data.data.transaction.trans.payments[0].PAYMENT_AMOUNT : 0;
    if (url === cart_url) {
      var item_skus = page_data && page_data.data && page_data.data.transaction && page_data.data.transaction.order && page_data.data.transaction.order.items ? page_data.data.transaction.order.items : [];
      if (item_skus.length) {
        for (i = 0, ii = item_skus.length; i < ii; i += 1) {
          productarray.push({
            'product': {
              'name': item_skus[i].prod.PROD_RGN_NAME, //PRODUCT NAME
              'sku': item_skus[i].sku.SKU_ID, //PRODUCT SKU OR UNIQUE IDENTIFIER
              'price': item_skus[i].sku.PRICE //SINGLE PRODUCT PRICE
            },
            'quantity': item_skus[i].itemForm.QTY.value //NUMBER OF PRODUCTS
          });
        }
      }
      lpTag.sdes = lpTag.sdes || [];
      lpTag.sdes.push({
        'type': 'cart', //MANDATORY
        'total': totalCost, //TOTAL VALUE OF THE CART AFTER DISCOUNT
        'numItems': item_skus[0].length,
        'products': productarray
      });
    } else if (url === confirmation_url) {
      var transaction_skus = page_data && page_data.data && page_data.data.transaction && page_data.data.transaction.order && page_data.data.transaction.order.items ? page_data.data.transaction.order.items : [];
      var orderId = page_data && page_data.data && page_data.data.transaction && page_data.data.transaction.last_trans_id && page_data.data.transaction.last_trans_id.TRANS_ID ? page_data.data.transaction.last_trans_id.TRANS_ID : '';

      if (transaction_skus.length) {
        productarray = [];
        for (i = 0, ii = transaction_skus.length; i < ii; i += 1) {
          productarray.push({
            'product': {
              'name': transaction_skus[i].prod.PROD_RGN_NAME, //PRODUCT NAME
              'sku': transaction_skus[i].sku.SKU_ID, //PRODUCT SKU OR UNIQUE IDENTIFIER
              'price': transaction_skus[i].sku.PRICE //SINGLE PRODUCT PRICE
            },
            'quantity': transaction_skus[i].itemForm.QTY.value //NUMBER OF PRODUCTS
          });
        }
      }

      lpTag.sdes = lpTag.sdes || [];
      lpTag.sdes.push({
        'type': 'purchase', //MANDATORY
        'total': totalCost,
        'orderId': orderId, //UNIQUE ORDER ID OR RECEIPT ID
        'cart': {
          'products': productarray
        }
      });
    } else if (url.match(prod_url)) {
      lpTag.sdes = lpTag.sdes || [];
      var prod_name = page_data && page_data.catalog && page_data.catalog.spp && page_data.catalog.spp.rpcdata && page_data.catalog.spp.rpcdata.products && page_data.catalog.spp.rpcdata.products[0] && page_data.catalog.spp.rpcdata.products[0].PROD_RGN_NAME ? page_data.catalog.spp.rpcdata.products[0].PROD_RGN_NAME : '';
      var cat_id = page_data && page_data.catalog && page_data.catalog.spp && page_data.catalog.spp.rpcdata && page_data.catalog.spp.rpcdata.products && page_data.catalog.spp.rpcdata.products[0] && page_data.catalog.spp.rpcdata.products[0].PARENT_CAT_ID ? page_data.catalog.spp.rpcdata.products[0].PARENT_CAT_ID : '';
      var sku_id = page_data && page_data.catalog && page_data.catalog.spp && page_data.catalog.spp.rpcdata && page_data.catalog.spp.rpcdata.products && page_data.catalog.spp.rpcdata.products[0] && page_data.catalog.spp.rpcdata.products[0].skus[0] && page_data.catalog.spp.rpcdata.products[0].skus[0].SKU_ID ? page_data.catalog.spp.rpcdata.products[0].skus[0].SKU_ID : '';
      var price = page_data && page_data.catalog && page_data.catalog.spp && page_data.catalog.spp.rpcdata && page_data.catalog.spp.rpcdata.products && page_data.catalog.spp.rpcdata.products[0] && page_data.catalog.spp.rpcdata.products[0].skus[0] && page_data.catalog.spp.rpcdata.products[0].skus[0].PRICE ? page_data.catalog.spp.rpcdata.products[0].skus[0].PRICE : '';
      lpTag.sdes.push({
        'type': 'prodView', //MANDATORY
        'products': [{ //ARRAY OF PRODUCTS
          'product': {
            'name': prod_name, //PRODUCT NAME
            'category': cat_id, //PRODUCT CATEGORY NAME
            'sku': sku_id, //PRODUCT SKU OR UNIQUE IDENTIFIER
            'price': price //SINGLE PRODUCT PRICE
          }
        }]
      });
    }
  });
})(jQuery);
